const ticketLinkFactory = function(saleId) {
  return `${process.env.VUE_APP_API_URL}print/store/ticket2/${saleId}`;
};

export { ticketLinkFactory };
